var START_MARK_NAME = 'page_load_start';
var LOAD_TIME_NAME = 'page_load_time';
function safeWindowCb(cb) {
  if (typeof window !== 'undefined') {
    return cb();
  }
}
export function measure(cb) {
  return safeWindowCb(function () {
    var metric = performance.now();
    var data = {
      page_load_time_from_navigation: metric
    };
    if (performance.getEntriesByName(START_MARK_NAME).length > 0) {
      data.page_load_time = performance.measure(LOAD_TIME_NAME, START_MARK_NAME).duration;
    }
    if (cb) {
      return cb(data);
    }
    return data;
  });
}